{
	"shell": {
		"nav": "Your pages",
		"signOut": "Sign out",
		"openMenu": "Open menu",
		"closeMenu": "Close menu",
		"tabs": {
			"profile": "Profile",
			"events": "My events",
			"medals": "My medals",
			"travel": "Travel"
		}
	},
	"profile": {
		"title": "Profile",
		"photoAlt": "Your accreditation photo",
		"noPhoto": "No photo yet",
		"cardsTitle": "Your cards",
		"cardsHint": "Your organisation registers your cards. You can finish a card they started; ask them about anything else.",
		"noCards": "No cards yet.",
		"showProgress": "Show progress",
		"hideProgress": "Hide progress",
		"loadFailed": "Your profile could not be loaded.",
		"retry": "Try again",
		"contactTitle": "Contact details",
		"contactHint": "Only you and the Games organisers see these. Your name, ID and photo are changed by your organisation.",
		"emergencyTitle": "Emergency contact",
		"fields": {
			"email_address": "Email",
			"phone_country_code": "Country code",
			"phone_number": "Phone number",
			"residential_address": "Home address",
			"emergency_contact_name": "Name",
			"emergency_contact_relationship": "Relationship",
			"emergency_phone_country_code": "Country code",
			"emergency_phone_number": "Phone number"
		},
		"save": "Save changes",
		"saved": "Contact details saved.",
		"unchanged": "Nothing changed.",
		"stale": "Your details were changed somewhere else. The latest version is shown; make your change again.",
		"saveFailed": "Your contact details could not be saved.",
		"tiles": {
			"title": "At a glance",
			"nextUp": "Next up",
			"live": "Live now",
			"venueTbc": "Venue to be confirmed",
			"nothingScheduled": "Nothing scheduled yet",
			"medals": "Medals",
			"medal": {
				"GOLD_one": "{{count}} gold medal",
				"GOLD_other": "{{count}} gold medals",
				"SILVER_one": "{{count}} silver medal",
				"SILVER_other": "{{count}} silver medals",
				"BRONZE_one": "{{count}} bronze medal",
				"BRONZE_other": "{{count}} bronze medals"
			},
			"medalsTotal_one": "{{count}} medal",
			"medalsTotal_other": "{{count}} medals",
			"noMedals": "No medals yet",
			"loadFailed": "Could not load this."
		},
		"contact": {
			"edit": "Edit",
			"cancel": "Cancel",
			"notGiven": "Not given",
			"phone": "Phone"
		},
		"finish": {
			"title": "Finish your registration",
			"titleReturned": "Your organisation sent your registration back",
			"yours_one": "{{count}} thing left for you to add.",
			"yours_other": "{{count}} things left for you to add.",
			"orgOnly_one": "Your part is done. Your organisation still needs to add {{count}} thing.",
			"orgOnly_other": "Your part is done. Your organisation still needs to add {{count}} things.",
			"ready": "Everything is in. Check it and submit.",
			"button": "Continue registration",
			"rowLink": "Finish registration"
		},
		"digitalCard": {
			"show": "Digital card",
			"hide": "Hide card",
			"loading": "Loading your card…",
			"loadFailed": "Your card could not be loaded.",
			"validUntil": "Valid until {{date}}",
			"noQr": "The QR code appears here once your card is activated."
		}
	},
	"status": {
		"DRAFT": "Draft",
		"SUBMITTED": "Submitted",
		"PENDING": "Pending",
		"APPROVED": "Approved",
		"RETURN": "Returned",
		"REJECTED": "Rejected",
		"WITHDRAWN": "Withdrawn"
	},
	"events": {
		"title": "My events",
		"empty": "You are not entered in any event yet.",
		"emptyHint": "Your NOC enters you. Events appear here as soon as they do.",
		"loadFailed": "Your events could not be loaded.",
		"primary": "Primary",
		"reserve": "Reserve",
		"entered": "Entered",
		"noSchedule": "Not scheduled yet",
		"venueTbc": "Venue to be confirmed",
		"rank": "Rank {{rank}}",
		"cancelled": "Cancelled",
		"live": "Live",
		"official": "Official",
		"unofficial": "Unofficial",
		"previous": "Previous",
		"next": "Next",
		"pageOf": "Page {{page}} of {{pages}}",
		"retry": "Try again",
		"loadFailedHint": "Check your connection and try again.",
		"sessions_one": "{{count}} session",
		"sessions_other": "{{count}} sessions",
		"nextUp": "Next up",
		"postponed": "Postponed",
		"delayed": "Delayed",
		"interrupted": "Interrupted",
		"eventOfSport": "{{sport}}, {{event}}",
		"unscheduledHint": "Times appear here once the schedule is set."
	},
	"medals": {
		"title": "My medals",
		"empty": "No medals yet.",
		"emptyHint": "A medal shows here once it is awarded.",
		"loadFailed": "Your medals could not be loaded.",
		"GOLD": "Gold",
		"SILVER": "Silver",
		"BRONZE": "Bronze",
		"count_one": "{{count}} medal",
		"count_other": "{{count}} medals",
		"awardedOn": "Awarded {{date}}",
		"retry": "Try again",
		"loadFailedHint": "Check your connection and try again.",
		"tallyLabel": "Your medal tally",
		"total": "Total"
	},
	"fnb": {
		"tab": "Food & Beverage",
		"title": "Food & Beverage",
		"loadFailed": "Your meals could not be loaded.",
		"loadFailedHint": "Check your connection and try again.",
		"retry": "Try again",
		"noCards": "No accreditation yet",
		"noCardsHint": "Your meals follow your accreditation card.",
		"entitled": "Meals included",
		"notEntitled": "Not entitled to meals",
		"notEntitledHint": "Your accreditation does not include meals. Ask your team manager if you think this is wrong.",
		"notApprovedHint": "Meals start once your accreditation is approved.",
		"yourDiet": "Your diet",
		"noDiet": "No special diet",
		"today": "Today, {{date}}",
		"zoneNote": "Hall times are local time at the Games ({{zone}}).",
		"noHall": "No dining hall yet — it follows your room",
		"noHallRoom": "Your building does not have a dining hall yet. It shows here once one is set.",
		"noHallNoRoom": "Your dining hall shows here once you have a room.",
		"mealNoHall": "No hall for this meal",
		"served": "Served {{time}}",
		"state": {
			"OPEN": "Serving now",
			"DONE": "Finished",
			"LATER": "Later"
		},
		"hallTitle": "Your dining hall",
		"phone": "Phone",
		"hallNotOpen": "This hall is not open to your team or category. Ask your team manager.",
		"hallDiets": "Special diets served:",
		"hallDietsNone": "none listed",
		"kitchenStandard": "Every Games kitchen is {{diets}}.",
		"dietNotListed": "This hall does not list {{diet}}. Ask the hall staff.",
		"recentTitle": "Recent meals",
		"recentHint_one": "The last {{count}} day",
		"recentHint_other": "The last {{count}} days",
		"recentEmpty": "No meals served yet.",
		"detail": {
			"back": "Back to Food & Beverage",
			"open": "Open {{hall}}: hours, diets and your meals there",
			"openHint": "Hours, diets and your meals here",
			"loadFailed": "This dining hall could not be loaded.",
			"notFound": "This is not one of your dining halls.",
			"notFoundHint": "You can open only the halls where you eat. Go back to Food & Beverage to see yours.",
			"openToYou": "Open to you",
			"notOpenToYou": "Not open to you",
			"openMaps": "Open in Maps",
			"call": "Call {{phone}}",
			"sessionsTitle": "Meal times",
			"eatHereToday": "You eat here today",
			"notHereToday": "Not here today",
			"noMealsToday": "You do not eat here today. This hall is for an upcoming stay.",
			"yourDietMark": "your diet",
			"yourDietHint": "Your diet is highlighted.",
			"historyTitle": "Your meals here",
			"historyEmpty": "No meals served to you here in these days."
		}
	},
	"registration": {
		"title": "Finish your registration",
		"cardLine": "{{games}}, {{category}}",
		"backToProfile": "Back to your profile",
		"loadFailed": "Your registration could not be loaded.",
		"notFound": {
			"title": "This registration could not be found",
			"body": "It may not be one of your cards. Go back to your profile and open it from there."
		},
		"stepsLabel": "Registration steps",
		"steps": {
			"contact": "Contact and medical",
			"travel": "Travel",
			"card": "Photo and card name",
			"review": "Review and submit"
		},
		"stepOf": "Step {{n}} of {{total}}: {{name}}",
		"stepOwes": "Something still to add",
		"stepHint": {
			"contact": "How the Games can reach you, who to call in an emergency, and what the medical team should know.",
			"travel": "When and how you arrive and leave. You can add this later if you do not know yet.",
			"card": "Your photo and the names printed on your card and in results.",
			"review": "Check everything, then submit it to your organisation."
		},
		"travelTyped": "Type your flight number, date and time as they are on your ticket.",
		"previous": "Back",
		"continue": "Continue",
		"saveContinue": "Save and continue",
		"unsaved": "Changes not saved yet",
		"saved": "Saved.",
		"saveFailed": "Your changes could not be saved",
		"submitFailed": "Your registration could not be submitted",
		"required": "Required",
		"invalid": "Check this value.",
		"contactFirst": "Add your email and mobile number first. They are needed before anything can be saved.",
		"neededToSubmit": "Needed to submit",
		"optional": "Optional",
		"stale": {
			"title": "This registration was changed somewhere else",
			"body": "The latest version is shown now. Check it and make your change again."
		},
		"closed": {
			"title": "Registration is closed",
			"body": "Your organisation's registration window is closed, so this card cannot be submitted now. What you saved is kept."
		},
		"returned": {
			"title": "Sent back to you",
			"body": "Your organisation returned this registration. Make the changes they asked for, then submit it again.",
			"remarkLabel": "What they asked you to change"
		},
		"leave": {
			"title": "Leave without saving?",
			"body": "Your changes on this page are not saved yet.",
			"stay": "Stay",
			"discard": "Leave"
		},
		"locked": {
			"title": "Your registration is with your organisation",
			"body": "It has been submitted. Your organisation and the host take it from here. If something needs to change, ask your organisation."
		},
		"submitted": {
			"title": "Submitted",
			"body": "Your organisation and the host take it from here. You can follow each step on your profile."
		},
		"review": {
			"allDone": "Everything needed is here. You can submit.",
			"yoursTitle_one": "{{count}} thing for you to add",
			"yoursTitle_other": "{{count}} things for you to add",
			"orgTitle_one": "{{count}} thing your organisation still needs to add",
			"orgTitle_other": "{{count}} things your organisation still needs to add",
			"orgHint": "You cannot change these. Ask your organisation to add them.",
			"add": "Add",
			"edit": "Edit",
			"editSection": "Edit {{section}}",
			"notGiven": "Not given",
			"missingValue": "Missing",
			"notAdded": "Not added yet",
			"yes": "Yes",
			"no": "No",
			"photo": "Photo",
			"tvPhoto": "TV photo",
			"noPhoto": "No photo",
			"submitHint": "Once you submit, you can no longer change these details here. Your organisation still can.",
			"notYet": "Submit becomes available once everything needed is added.",
			"savedOnSubmit": "Your unsaved changes are saved when you submit.",
			"submit": "Submit registration",
			"resubmit": "Submit again"
		},
		"missing": {
			"identification_number": "ID or passport number",
			"first_middle_name": "Name as on your ID",
			"gender": "Sex",
			"phone_number": "Mobile number",
			"email_address": "Email",
			"accreditation_name": "Name on your card",
			"sub_function_id": "Your function",
			"sport_id": "Your sport",
			"consent_truthfulness": "Declaration that the details are true",
			"consent_pdpa": "Data protection consent",
			"photo": "Accreditation photo"
		},
		"wording": {
			"contactNameHint": "The person to ask for when the Games call or write to you. Leave it empty to use your own name.",
			"travelLater": "You can add or change this until you submit. It is used for your airport welcome and transport.",
			"transferArrival": "From the entry point to your hotel or venue.",
			"transferDeparture": "From your hotel to the entry point.",
			"namesCard": "Name on your card",
			"nameOnCard": "Name on your card"
		},
		"photoSaveFirst": "Save your changes first, then add or change your photo.",
		"saveChanges": "Save changes",
		"declarations": {
			"title": "Your declarations",
			"truthfulness": "I declare that the details in this registration are true and complete.",
			"pdpa": "I agree that the Games organisers may process my personal data for accreditation, security and Games services.",
			"tickBoth": "Tick both declarations to submit."
		}
	},
	"travel": {
		"title": "Travel",
		"loadFailed": "Your travel could not be loaded",
		"loadFailedHint": "Check your connection and try again.",
		"retry": "Try again",
		"empty": "No travel on record yet",
		"emptyHint": "Your organisation adds your arrival and departure. They show here once entered.",
		"emptyContinue": "Add it in your registration",
		"cardLabel": "Card {{no}}",
		"continue": "Add or change travel in your registration",
		"arrival": "Arrival",
		"departure": "Departure",
		"noArrival": "No arrival on record yet",
		"noDeparture": "No departure on record yet",
		"entryPoint": "Entry point: {{entry}}",
		"readOnly": "Your organisation and the Games host keep this up to date. Ask your organisation for any change.",
		"transfer": {
			"own_way": "No Games transfer: you make your own way",
			"waiting_approval": "Your transfer is arranged once your card is approved",
			"not_arranged": "Your transfer has not been arranged yet",
			"pending": "Transfer requested, driver to be confirmed",
			"driver": "Transfer arranged, a driver is assigned",
			"recheck": "Your transfer is being re-checked after a time change",
			"cancelled": "This transfer was cancelled. Please contact your organisation.",
			"pickup": "Pickup {{day}}, {{time}} {{zone}}"
		},
		"detail": {
			"back": "Back to my travel",
			"notFound": "This trip was not found",
			"notFoundHint": "It may have been removed, or it is not on one of your cards.",
			"title": "{{direction}}, {{day}}",
			"open": "Open {{direction}} details",
			"connectionAtRisk": "Your connection is at risk: the time to change flights is very short, or a connecting flight was cancelled or diverted. Contact your organisation.",
			"flightTitle": "Flight",
			"flightsTitle_one": "{{count}} flight",
			"flightsTitle_other": "{{count}} flights",
			"serviceTitle": "Service",
			"service": "Service",
			"comingFrom": "Coming from",
			"goingTo": "Going to",
			"arrives": "Arrives",
			"departs": "Departs",
			"at": "{{day}}, {{time}} {{zone}}",
			"yourTime": "Your time: {{time}}",
			"scheduledWas": "Scheduled:",
			"timeUnknown": "Time not known yet",
			"airportUnknown": "Airport not known",
			"mainFlight": "Main flight ({{n}} of {{total}})",
			"connection": "Connecting flight ({{n}} of {{total}})",
			"delayedBy_one": "Running {{count}} minute late",
			"delayedBy_other": "Running {{count}} minutes late",
			"from": "From",
			"to": "To",
			"terminal": "Terminal {{terminal}}",
			"entryPointTitle": "Entry point",
			"entryPointName": "Name",
			"afterLanding": "After landing",
			"beforeDeparture": "Before departure",
			"dwell_one": "Your pickup is about {{count}} minute after landing",
			"dwell_other": "Your pickup is about {{count}} minutes after landing",
			"lead_one": "Be at the entry point {{count}} minute before departure",
			"lead_other": "Be at the entry point {{count}} minutes before departure",
			"readyAround": "Ready for pickup around",
			"beThereBy": "Be there by",
			"transferTitle": "Games transfer",
			"pickupTime": "Pickup time",
			"meetAt": "Where to meet",
			"openTransport": "See it in Transportation"
		}
	},
	"accommodation": {
		"tab": "Accommodation",
		"title": "My accommodation",
		"loadFailed": "Your accommodation could not be loaded.",
		"loadFailedHint": "Check your connection and try again.",
		"retry": "Try again",
		"empty": "No room assigned yet",
		"emptyHint": "Your organisation arranges it. Your room shows here once it is assigned.",
		"noRoom": "No room assigned yet — your organisation arranges it.",
		"cardNo": "Card {{card}}",
		"earlier": "Earlier stays",
		"state": {
			"ASSIGNED": "Not checked in yet",
			"IN": "Checked in",
			"OUT": "Checked out"
		},
		"type": {
			"VILLAGE": "Games Village",
			"HOTEL": "Hotel",
			"OTHER": "Accommodation"
		},
		"room": "Room",
		"bed": "Bed",
		"firstNight": "First night",
		"lastNight": "Last night",
		"nights_one": "{{count}} night",
		"nights_other": "{{count}} nights",
		"checkedInAt": "Checked in {{at}}",
		"checkOutBy": "Check out by {{time}} on {{date}}",
		"pastRoom": "{{building}}, room {{room}}",
		"pastDates": "{{from}} – {{to}}",
		"detail": {
			"viewDetails": "View details",
			"back": "My accommodation",
			"notFound": "Stay not found",
			"notFoundHint": "This stay is not on your card. Go back to see your accommodation.",
			"cardOf": "{{games}} · Card {{card}}",
			"code": "Code {{code}}",
			"address": "Address",
			"openInMaps": "Open in Maps",
			"yourRoom": "Your room",
			"floor": "Floor",
			"nightsLabel": "Nights",
			"checkInOut": "Check-in & check-out",
			"checkInFrom": "Check in from {{date}}",
			"checkedOutAt": "Checked out {{at}}",
			"localTime": "Times are local time at the Games.",
			"frontDesk": "Front desk",
			"deskHours": "Open {{from}} – {{to}}",
			"desk24h": "Open 24 hours",
			"call": "Call {{phone}}",
			"meals": "Meals",
			"eatAt": "You eat at {{hall}}",
			"noHall": "Your dining hall has not been set yet.",
			"toFnb": "See your meals in Food & Beverage",
			"helpTitle": "Need help?",
			"helpBody": "Contact your team manager or your organisation."
		}
	},
	"transport": {
		"tab": "Transportation",
		"title": "My transport",
		"upcoming": "Upcoming",
		"past": "Recent trips",
		"noUpcoming": "No upcoming trips.",
		"empty": "No transport booked yet",
		"emptyHint": "Your transfers will appear here once your delegation or the transport desk books them.",
		"loadFailed": "Could not load your transport",
		"loadFailedHint": "Check your connection and try again.",
		"retry": "Try again",
		"pickup": "Pickup",
		"from": "From",
		"to": "To",
		"flight": "Flight {{flight}}",
		"service": "Service {{service}}",
		"returnPickup": "Return pickup",
		"driver": "Driver: {{name}}",
		"callDriver": "Call {{name}}",
		"noVehicle": "The vehicle and driver will show here once they are assigned.",
		"detail": {
			"back": "My transport",
			"title": "Trip details",
			"notFound": "Trip not found",
			"notFoundHint": "This trip is no longer on your list. It may have been changed or cancelled.",
			"pickupTime": "Pickup time",
			"progress": "Trip progress",
			"steps": {
				"requested": "Requested",
				"assigned": "Driver assigned",
				"onTheWay": "On the way",
				"arrived": "Arrived"
			},
			"cancelled": "This trip was cancelled.",
			"rejected": "This trip was not accepted by the transport desk.",
			"route": "Route",
			"pickupPlace": "Pickup",
			"dropoffPlace": "Drop-off",
			"terminal": "Terminal {{terminal}}",
			"openInMaps": "Open in Maps",
			"meets": "Meets",
			"lands": "Lands",
			"departs": "Departs",
			"vehicle": "Vehicle and driver",
			"driver": "Driver",
			"call": "Call",
			"whatsapp": "WhatsApp",
			"whatsappDriver": "Message {{name}} on WhatsApp",
			"otherWay": "The other way",
			"linkedArrival": "Your arrival transfer",
			"linkedDeparture": "Your departure transfer"
		}
	}
}
